import React from 'react';
import Input from 'components/ui/input';

export function DocumentField({
  id,
  label,
  placeholder = '',
  value,
  onChange,
}) {
  return (
    <div className="">
      <Input
        labelClassName="form-label mb-1"
        type="text"
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
